import * as React from "react";
import places from 'places.js';

interface Props {
    disabled?: any,
    value?: any,
    value_str?: any;
    label?: any;
    required?: any;
    placeholder?: any,
    onSuggestSelect?: any,
    onCancel?: any,
    showSave?: any,
    onSubmit?: any,
    success?: any,
    loading?: any,
    error?: any,
}

interface State {
    empty?: boolean;
}

export default class GeoAutocompleteControl extends React.Component<Props, State> {
    state = {
    } as State;

    private $q: any;
    private $ref: any;

    componentDidMount() {
        window.addEventListener('CookiebotOnConsentReady', function (e) {
            if (Cookiebot.consent.marketing) {
                this.$q = places({
                    container: this.$ref,
                    type: ['city', 'address'],
                    countries: ['it'],
                    appId: (window as any).CONFIG.app.algolia_appid,
                    apiKey: (window as any).CONFIG.app.algolia_key,
                    templates: {
                        value: function(val) {
                            var pts = [
                                [val.city, val.county, val.country].filter(function (token) { return token !== undefined; }).join(', ')
                            ];
                            return val.name + ' (' + pts.join(',') + ')';
                        },
                        suggestion: function(suggestion) {
                            var i = suggestion.highlight;
                            var type = suggestion.type,
                                highlight = suggestion.highlight;
                            var pts = [
                                '<span class="ap-name">' + highlight.name + '</span>',
                                '<span class="ap-address">' + [highlight.city, /*administrative,*/ highlight.county, highlight.country].filter(function (token) { return token !== undefined; }).join(', ') + '</span>'
                            ];
                            if (suggestion.postcode) {
                                pts.push('<span class="ap-postcode">' + suggestion.postcode + '</span>');
                            }
                            return pts.join('\n');
                        }
                    }
                });
            }
        }.bind(this), false);

        this.$q.on('change', (e: any) => {
            this.update(e.suggestion);
        });
        
        this.$ref.addEventListener('keydown', (e: any) => {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
            this.onChange();
        });
        this.onChange();

        this.$ref.value = this.props.value_str || "";
    }

    reset() {
        this.$ref.value = '';
        this.onChange();
    }

    onChange() {
        var val = this.$ref.value;
        this.setState({empty: val.length === 0});
    }

    update(suggestion) {
        const { onSuggestSelect } = this.props;
        if (onSuggestSelect) {
            onSuggestSelect(suggestion)
        }
    }

    render() {
        const { label, required, placeholder, value } = this.props;
        const { empty } = this.state;

        return (
        <div className={`field wicon ${required ? 'required' : ''}`}>
            {label && <label>{label}</label>}
            <div>
                <span className="icon-marker1"></span>
                {!empty && <span className="icon-close" onClick={() => this.reset()}></span>}

                <div>
                    <input
                        ref={(ref) => this.$ref = ref}
                        type="text"
                        placeholder={placeholder}
                        className={!empty ? 'not-empty' : ''}
                        autoComplete={"false"}
                    />
                </div>
            </div>
        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/GeoAutocompleteControl.tsx